import React from "react";
import AdfitWebComponent from "react-adfit-web-component";

class IntegratedAdfitComponent extends React.Component {
  render() {
    return (
      <>
        <AdfitWebComponent adUnit="DAN-hXtt3Qdbuh1IgpVU" />
        <AdfitWebComponent adUnit="DAN-rsN4qA50NaO82nvl" />
      </>
    );
  }
}

export default IntegratedAdfitComponent;
